/* =========================================================
   VALARNI – My Wishlist page
   Product data comes from Shopify's official /products/<handle>.js
   (live price, stock, variants, images). Colours linked through
   custom.produits_lies come from /products/<handle>?view=vl-wish.
   Real Add to cart (opens the existing cart drawer).
   ========================================================= */
(function () {
  'use strict';

  var root = document.querySelector('[data-vlw]');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = '1';

  var KEY = 'vl_wishlist';
  var grid = root.querySelector('[data-vlw-grid]');
  var bar = root.querySelector('[data-vlw-bar]');
  var emptyEl = root.querySelector('[data-vlw-empty]');
  var noticeEl = root.querySelector('[data-vlw-notice]');
  var countEl = root.querySelector('[data-vlw-count]');
  var countLbl = root.querySelector('[data-vlw-count-label]');
  var sortEl = root.querySelector('[data-vlw-sort]');
  if (sortEl) {
    /* only: Recently added / Price low-high / Price high-low */
    Array.prototype.slice.call(sortEl.options).forEach(function (o) {
      if (['recent', 'price-asc', 'price-desc'].indexOf(o.value) === -1) o.remove();
    });
    var sw = sortEl.parentElement;
    if (sw) sw.className = 'vlw-sortsel';
  }
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || root.dataset.root || '/';
  var MONEY = root.dataset.moneyFormat || '{{amount}}€';
  var NF = null;
  /* Prices come in the visitor's currency (GBP, USD, AUD…): show that currency's symbol, not the shop's € */
  (function () {
    var cur = window.Shopify && Shopify.currency && Shopify.currency.active;
    if (!cur || cur === 'EUR') return;
    var sym = cur;
    try { new Intl.NumberFormat('en', { style: 'currency', currency: cur, currencyDisplay: 'narrowSymbol' }).formatToParts(0).forEach(function (p) { if (p.type === 'currency') sym = p.value; }); } catch (e) {}
    MONEY = MONEY.replace(/€|EUR|&euro;/g, sym);
    if (MONEY.indexOf(sym) === -1) MONEY = MONEY + sym;
    /* same layout as the rest of the site for that currency ($89.90, £89.90…) */
    try { NF = new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: cur, currencyDisplay: 'narrowSymbol' }); } catch (e) { NF = null; }
  })();
  var SHOW_SAVE = root.dataset.showSave === 'true';
  var HEART = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 20.3s-7.8-4.6-7.8-10.3A4.5 4.5 0 0 1 12 7.2a4.5 4.5 0 0 1 7.8 2.8c0 5.7-7.8 10.3-7.8 10.3z"/></svg>';

  var groups = {};
  var errors = {};
  /* Translated texts come from window.VL_T (snippet vl-i18n), English as fallback */
  function L(k, d, v) { var t = (window.VL_T && window.VL_T[k]) || d; if (v) Object.keys(v).forEach(function (n) { t = t.split('{' + n + '}').join(v[n]); }); return t; }

  function getList() {
    if (window.VLWishlist) return VLWishlist.get();
    try { var w = JSON.parse(localStorage.getItem(KEY) || '[]'); return Array.isArray(w) ? w.filter(function (h) { return typeof h === 'string' && h; }) : []; } catch (e) { return []; }
  }
  function setList(list) {
    if (window.VLWishlist) return VLWishlist.set(list);
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
    document.dispatchEvent(new CustomEvent('wishlist:update'));
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function money(cents) {
    cents = Math.round(cents || 0);
    if (NF) return NF.format(cents / 100);
    function fmt(n, dec, thou, decSep) {
      var s = (n / 100).toFixed(dec).split('.');
      var i = s[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou);
      return i + (dec ? decSep + s[1] : '');
    }
    return MONEY.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      switch (k) {
        case 'amount': return fmt(cents, 2, ',', '.');
        case 'amount_no_decimals': return fmt(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return fmt(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fmt(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return fmt(cents, 2, "'", '.');
        case 'amount_with_space_separator': return fmt(cents, 2, ' ', ',');
        default: return fmt(cents, 2, ',', '.');
      }
    }).replace(/<[^>]*>/g, '');
  }
  function kind(name) {
    var n = String(name || '').toLowerCase().trim();
    if (n === 'color' || n === 'couleur' || n === 'colour' || n === 'coloris') return 'color';
    if (n === 'size' || n === 'taille' || n === 'pointure' || n === 'talla' || n === 'número' || n === 'numero') return 'size';
    return 'other';
  }
  function label(name) {
    var k = kind(name);
    if (k === 'color') return L('js.color', 'Color').toLowerCase();
    if (k === 'size') return L('js.size', 'Size').toLowerCase();
    return String(name || '').toLowerCase();
  }
  function cap(s) { return s.charAt(0).toUpperCase() + s.slice(1); }

  /* ---------- data loading ---------- */
  function base() { return ROOT.replace(/\/?$/, '/'); }
  function imgUrl(u) {
    if (!u) return null;
    if (typeof u === 'object') u = u.src || u.url || null;
    if (!u) return null;
    if (u.indexOf('//') === 0) u = 'https:' + u;
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=800';
  }
  /* official Shopify product JSON: prices in cents, real stock, variants, images */
  function productJS(handle) {
    return fetch(base() + 'products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) {
        if (r.status === 404) return null;
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      })
      .then(function (p) {
        if (!p) return null;
        var images = (p.images || []).map(imgUrl).filter(Boolean);
        return {
          handle: p.handle, title: p.title, url: p.url || (base() + 'products/' + p.handle), type: p.type || '',
          available: !!p.available,
          image: imgUrl(p.featured_image) || images[0] || null,
          image2: images[1] || null,
          options: (p.options || []).map(function (o) { return { name: typeof o === 'string' ? o : o.name, values: (o.values || []).map(String) }; }),
          variants: (p.variants || []).map(function (v) {
            return {
              id: v.id, title: v.title, available: !!v.available,
              options: (v.options || [v.option1, v.option2, v.option3].filter(function (x) { return x != null; })).map(String),
              price: Number(v.price) || 0, compare_at_price: Number(v.compare_at_price) || 0,
              image: imgUrl(v.featured_image)
            };
          })
        };
      });
  }
  /* colours linked via custom.produits_lies (labels + handles) */
  function linkedInfo(handle) {
    return fetch(base() + 'products/' + encodeURIComponent(handle) + '?view=vl-wish', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (t) { try { var d = JSON.parse(t); return d && Array.isArray(d.linked) ? d : null; } catch (e) { return null; } })
      .catch(function () { return null; });
  }
  function load(handle) {
    return Promise.all([productJS(handle), linkedInfo(handle)]).then(function (res) {
      var main = res[0], info = res[1];
      if (!main) return { gone: true };
      main.color_label = (info && info.color_label) || main.title;
      var links = (info && info.linked) || [];
      return Promise.all(links.map(function (l) {
        return productJS(l.handle).then(function (p) { if (p) p.color_label = l.color_label || p.title; return p; }, function () { return null; });
      })).then(function (linked) {
        return { product: main, linked: linked.filter(Boolean) };
      });
    });
  }
  function loadAll(handles) {
    var out = {}, i = 0, LIMIT = 6;
    return new Promise(function (resolve) {
      var active = 0;
      function next() {
        if (i >= handles.length && active === 0) return resolve(out);
        while (active < LIMIT && i < handles.length) {
          (function (h) {
            active++;
            load(h).then(function (d) { out[h] = d; }, function () { out[h] = { error: true }; })
              .then(function () { active--; next(); });
          })(handles[i++]);
        }
      }
      next();
    });
  }

  /* ---------- group state ---------- */
  function makeGroup(handle, data) {
    var products = [data.product].concat(data.linked || []);
    return { handle: handle, products: products, idx: 0, sel: {}, busy: false };
  }
  function cur(g) { return g.products[g.idx]; }
  function choiceOptions(p) {
    var out = [];
    (p.options || []).forEach(function (o, i) {
      if (o.values && o.values.length > 1) out.push({ name: o.name, index: i, values: o.values });
    });
    var rank = { color: 0, size: 1, other: 2 };
    return out.sort(function (a, b) { return (rank[kind(a.name)] - rank[kind(b.name)]) || (a.index - b.index); });
  }
  function resolved(g) {
    var p = cur(g), opts = p.options || [];
    var wanted = opts.map(function (o) { return o.values.length === 1 ? o.values[0] : g.sel[o.name]; });
    if (wanted.some(function (v) { return v == null || v === ''; })) return null;
    for (var i = 0; i < p.variants.length; i++) {
      var v = p.variants[i], ok = true;
      for (var j = 0; j < wanted.length; j++) if (v.options[j] !== wanted[j]) { ok = false; break; }
      if (ok) return v;
    }
    return null;
  }
  function valueState(g, oi, val) {
    var p = cur(g), exists = false, avail = false;
    p.variants.forEach(function (v) {
      if (v.options[oi] !== val) return;
      for (var j = 0; j < p.options.length; j++) {
        if (j === oi) continue;
        var s = p.options[j].values.length === 1 ? p.options[j].values[0] : g.sel[p.options[j].name];
        if (s && v.options[j] !== s) return;
      }
      exists = true;
      if (v.available) avail = true;
    });
    return { exists: exists, avail: avail };
  }
  function displayVariant(g) {
    var p = cur(g), v = resolved(g);
    if (v) return v;
    var colorOpt = choiceOptions(p).filter(function (o) { return kind(o.name) === 'color'; })[0];
    var list = p.variants;
    if (colorOpt && g.sel[colorOpt.name]) list = list.filter(function (x) { return x.options[colorOpt.index] === g.sel[colorOpt.name]; });
    return list.filter(function (x) { return x.available; })[0] || list[0] || p.variants[0];
  }

  /* ---------- rendering ---------- */
  function cardHTML(g) {
    var p = cur(g), v = displayVariant(g), r = resolved(g);
    var img = (v && v.image) || p.image;
    var img2 = (img === p.image) ? p.image2 : null;
    var onSale = v && v.compare_at_price > v.price;
    var pct = onSale ? Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) : 0;

    var selects = [];
    if (g.products.length > 1) {
      selects.push('<span class="vlw-select"><select data-vlw-product aria-label="' + esc(L('js.color', 'Color')) + '">' +
        g.products.map(function (lp, i) {
          return '<option value="' + i + '"' + (i === g.idx ? ' selected' : '') + '>' + esc(lp.color_label) + (lp.available ? '' : ' – ' + L('js.sold_out', 'Sold out')) + '</option>';
        }).join('') + '</select></span>');
    }
    choiceOptions(p).forEach(function (o) {
      var lb = label(o.name);
      var html = '<span class="vlw-select"><select data-vlw-opt="' + esc(o.name) + '" aria-label="' + esc(cap(lb)) + '">' +
        '<option value="">' + esc(L('js.select', 'Select')) + ' ' + esc(lb) + '</option>';
      o.values.forEach(function (val) {
        var st = valueState(g, o.index, val);
        if (!st.exists) return;
        html += '<option value="' + esc(val) + '"' + (g.sel[o.name] === val ? ' selected' : '') + (st.avail ? '' : ' disabled') + '>' +
          esc(val) + (st.avail ? '' : ' – ' + L('js.sold_out', 'Sold out')) + '</option>';
      });
      selects.push(html + '</select></span>');
    });

    var btnLabel = L('js.add_to_cart', 'Add to cart'), btnAttr = '';
    if (!p.available || (r && !r.available)) { btnLabel = L('js.sold_out', 'Sold out'); btnAttr = ' disabled'; }

    return '' +
      '<div class="vlw-card__media">' +
        '<a class="vlw-card__link" href="' + esc(p.url) + '" aria-label="' + esc(p.title) + '">' +
          (img ? '<img class="vlw-card__img vlw-card__img--1" src="' + esc(img) + '" alt="' + esc(p.title) + '" loading="lazy" width="800" height="1000">' : '') +
          (img2 ? '<img class="vlw-card__img vlw-card__img--2" src="' + esc(img2) + '" alt="" loading="lazy" width="800" height="1000">' : '') +
        '</a>' +
        (!p.available ? '<span class="vlw-soldout-tag">' + L('js.sold_out', 'Sold out') + '</span>' : '') +
        '<button type="button" class="vlw-heart" data-vl-wish="' + esc(g.handle) + '" aria-pressed="true" aria-label="' + esc(L('js.wish_remove', 'Remove from wishlist')) + '">' + HEART + '</button>' +
      '</div>' +
      '<div class="vlw-card__info">' +
        '<a class="vlw-card__title" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
        (p.type ? '<p class="vlw-card__type">' + esc(p.type) + '</p>' : '') +
        '<div class="vlw-card__price' + (onSale ? ' is-sale' : '') + '">' +
          '<span class="vlw-price">' + esc(money(v ? v.price : 0)) + '</span>' +
          (onSale ? '<span class="vlw-price-old"><span class="visually-hidden">' + L('js.regular_price', 'Regular price') + '</span>' + esc(money(v.compare_at_price)) + '</span>' : '') +
          (SHOW_SAVE && onSale && pct > 0 ? '<span class="vlw-save">' + L('js.save_pct', 'SAVE {pct}%', { pct: pct }) + '</span>' : '') +
        '</div>' +
        '<div class="vlw-card__actions">' +
          (selects.length ? '<div class="vlw-card__selects vlw-card__selects--' + Math.min(selects.length, 2) + '">' + selects.join('') + '</div>' : '') +
          '<p class="vlw-card__msg" role="status" aria-live="polite"></p>' +
          '<button type="button" class="vlw-btn" data-vlw-add' + btnAttr + '>' + btnLabel + '</button>' +
        '</div>' +
      '</div>';
  }

  function renderCard(li, g) {
    li.className = 'vlw-card' + (!cur(g).available ? ' is-soldout' : '');
    li.innerHTML = cardHTML(g);
  }

  function errorCard(handle) {
    var li = document.createElement('li');
    li.className = 'vlw-card';
    li.dataset.handle = handle;
    li.innerHTML = '<div class="vlw-card__media"><button type="button" class="vlw-heart" data-vl-wish="' + esc(handle) + '" aria-pressed="true" aria-label="' + esc(L('js.wish_remove', 'Remove from wishlist')) + '">' + HEART + '</button></div>' +
      '<div class="vlw-card__info"><p class="vlw-card__msg">' + L('js.item_not_loaded', 'This item could not be loaded.') + '</p>' +
      '<div class="vlw-card__actions"><button type="button" class="vlw-btn" data-vlw-retry>' + L('js.try_again', 'Try again') + '</button></div></div>';
    return li;
  }

  function sortValue(g) { var v = displayVariant(g); return v ? v.price : 0; }
  function ordered() {
    var hs = getList().slice();
    var mode = sortEl ? sortEl.value : 'recent';
    if (mode === 'recent') hs.reverse();
    if (mode === 'price-asc' || mode === 'price-desc') {
      hs.sort(function (a, b) {
        var ga = groups[a], gb = groups[b];
        if (!ga || !gb) return ga ? -1 : gb ? 1 : 0;
        var d = sortValue(ga) - sortValue(gb);
        return mode === 'price-asc' ? d : -d;
      });
    }
    return hs;
  }

  function updateCount(n) {
    if (countEl) countEl.textContent = n;
    if (countLbl) countLbl.textContent = n === 1 ? L('js.product', 'product') : L('js.products', 'products');
  }

  function safeCard(h) {
    var li;
    if (groups[h]) {
      li = document.createElement('li');
      li.dataset.handle = h;
      try { renderCard(li, groups[h]); }
      catch (err) { if (window.console) console.error('[Wishlist] card', h, err); li = errorCard(h); }
    } else li = errorCard(h);
    return li;
  }
  function paint() {
    var hs;
    try { hs = ordered().filter(function (h) { return groups[h] || errors[h]; }); }
    catch (err) { hs = getList().filter(function (h) { return groups[h] || errors[h]; }); }
    grid.setAttribute('aria-busy', 'false');
    if (!hs.length) {
      grid.innerHTML = '';
      grid.hidden = true;
      bar.hidden = true;
      emptyEl.hidden = false;
      updateCount(0);
      return;
    }
    var existing = {};
    Array.prototype.forEach.call(grid.children, function (li) { if (li.dataset.handle) existing[li.dataset.handle] = li; });
    var frag = document.createDocumentFragment();
    hs.forEach(function (h) { frag.appendChild(existing[h] || safeCard(h)); });
    grid.innerHTML = '';
    grid.appendChild(frag);
    emptyEl.hidden = true;
    grid.hidden = false;
    bar.hidden = false;
    updateCount(hs.length);
  }

  function notice(msg) {
    if (!msg) { noticeEl.hidden = true; noticeEl.textContent = ''; return; }
    noticeEl.textContent = msg;
    noticeEl.hidden = false;
  }

  function boot() {
    var list = getList();
    if (!list.length) { groups = {}; paint(); return; }
    var need = list.filter(function (h) { return !groups[h]; });
    loadAll(need).then(function (res) {
      try {
        var removed = 0;
        need.forEach(function (h) {
          var d = res[h];
          if (!d || d.error) { errors[h] = true; return; }
          delete errors[h];
          if (d.gone) { removed++; return; }
          groups[h] = makeGroup(h, d);
        });
        if (removed) {
          var keep = getList().filter(function (h) { return !(res[h] && res[h].gone); });
          setList(keep);
          notice(removed === 1 ? L('js.wish_removed_one', '1 saved item is no longer available and was removed from your wishlist.')
                               : L('js.wish_removed_many', '{n} saved items are no longer available and were removed from your wishlist.', { n: removed }));
        }
      } catch (err) { if (window.console) console.error('[Wishlist]', err); }
      paint();
    });
  }

  /* ---------- interactions ---------- */
  function groupOf(el) {
    var li = el.closest('.vlw-card');
    return li && groups[li.dataset.handle] ? { li: li, g: groups[li.dataset.handle] } : null;
  }
  function msg(li, text, ok) {
    var m = li.querySelector('.vlw-card__msg');
    if (!m) return;
    m.textContent = text || '';
    m.classList.toggle('is-ok', !!ok);
  }

  grid.addEventListener('change', function (e) {
    var t = e.target, x = groupOf(t);
    if (!x) return;
    var focusKey = t.hasAttribute('data-vlw-product') ? '[data-vlw-product]' : '[data-vlw-opt="' + (window.CSS && CSS.escape ? CSS.escape(t.dataset.vlwOpt) : t.dataset.vlwOpt) + '"]';
    if (t.hasAttribute('data-vlw-product')) {
      x.g.idx = parseInt(t.value, 10) || 0;
      x.g.sel = {};
    } else if (t.hasAttribute('data-vlw-opt')) {
      x.g.sel[t.dataset.vlwOpt] = t.value;
      var p = cur(x.g);
      p.options.forEach(function (o, oi) {
        var s = x.g.sel[o.name];
        if (s && o.name !== t.dataset.vlwOpt && !valueState(x.g, oi, s).exists) delete x.g.sel[o.name];
      });
    }
    renderCard(x.li, x.g);
    /* Keep keyboard focus on desktop only: on phones, focusing a <select> re-opens its picker straight away. */
    var finePointer = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    var again = finePointer ? x.li.querySelector(focusKey) : null;
    if (again) again.focus({ preventScroll: true });
  });

  grid.addEventListener('click', function (e) {
    var retry = e.target.closest('[data-vlw-retry]');
    if (retry) {
      var h = retry.closest('.vlw-card').dataset.handle;
      retry.closest('.vlw-card').remove();
      delete errors[h];
      boot();
      return;
    }
    var btn = e.target.closest('[data-vlw-add]');
    if (!btn) return;
    var x = groupOf(btn);
    if (!x || x.g.busy || btn.disabled) return;
    var v = resolved(x.g);
    if (!v) {
      var missing = choiceOptions(cur(x.g)).filter(function (o) { return !x.g.sel[o.name]; })[0];
      if (missing) {
        msg(x.li, L('js.please_select', 'Please select a {option}.', { option: label(missing.name) }));
        var s = x.li.querySelector('[data-vlw-opt="' + missing.name.replace(/"/g, '\\"') + '"]');
        if (s) { s.setAttribute('aria-invalid', 'true'); if (window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches) s.focus(); }
      } else {
        msg(x.li, L('js.combo_unavailable', 'This combination is not available.'));
      }
      return;
    }
    if (!v.available) { msg(x.li, L('js.option_sold_out', 'This option is sold out.')); return; }
    x.g.busy = true;
    btn.classList.add('is-loading');
    btn.setAttribute('aria-disabled', 'true');
    btn.textContent = L('js.adding', 'Adding…');
    msg(x.li, '');
    fetch(base() + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }] })
    }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (d) {
        if (!r.ok) throw new Error((d && (d.description || d.message)) || L('js.could_not_add', 'Could not add this item.'));
        return d;
      });
    }).then(function () {
      btn.textContent = L('js.added', 'Added ✓');
      msg(x.li, L('js.added_to_cart', 'Added to your cart.'), true);
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      if (!window.CartDrawer) {
        fetch(base() + 'cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
          document.querySelectorAll('[data-cart-count],.cart-count').forEach(function (n) { n.textContent = c.item_count; });
        }).catch(function () {});
      }
      setTimeout(function () { btn.textContent = L('js.add_to_cart', 'Add to cart'); msg(x.li, ''); }, 2200);
    }).catch(function (err) {
      btn.textContent = L('js.add_to_cart', 'Add to cart');
      msg(x.li, err && err.message ? err.message : L('js.network_error', 'Network error, please try again.'));
    }).then(function () {
      x.g.busy = false;
      btn.classList.remove('is-loading');
      btn.removeAttribute('aria-disabled');
    });
  });

  function onListChange() {
    var list = getList();
    var gone = Array.prototype.filter.call(grid.children, function (li) { return li.dataset.handle && list.indexOf(li.dataset.handle) === -1; });
    if (gone.length) {
      gone.forEach(function (li) { li.classList.add('is-leaving'); });
      setTimeout(function () {
        gone.forEach(function (li) { delete groups[li.dataset.handle]; delete errors[li.dataset.handle]; });
        paint();
      }, 220);
    }
    if (list.some(function (h) { return !groups[h] && !errors[h]; })) boot();
    else if (!gone.length) paint();
  }
  document.addEventListener('wishlist:update', onListChange);
  document.addEventListener('wishlist:external', onListChange);
  window.addEventListener('pageshow', function (e) { if (e.persisted) onListChange(); });
  if (sortEl) sortEl.addEventListener('change', function () { paint(); sortEl.blur(); });

  if (!window.VLWishlist) {
    grid.addEventListener('click', function (e) {
      var b = e.target.closest('[data-vl-wish]');
      if (!b) return;
      e.preventDefault();
      setList(getList().filter(function (h) { return h !== b.getAttribute('data-vl-wish'); }));
    });
  }

  boot();
})();
